/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const DownloadOffline: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="download-offline" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M705.67 1205.98C400.9875 1205.98 153.9775 958.97 153.9775 654.2875V615.7825H0V654.2875C0 1044.0125 315.945 1359.9575 705.67 1359.9575S1411.34 1044.0124999999998 1411.34 654.2875V615.7825H1257.3625V654.2875C1257.3625 958.97 1010.3524999999998 1205.98 705.67 1205.98zM782.6374999999999 262.7774999999999V756.9250000000001H628.66V262.7774999999999L436.22 455.2175L327.335 346.3324999999999L651.1 22.5674999999999C681.2325 -7.5650000000003 730.0225 -7.5650000000003 760.155 22.5674999999999L1083.9199999999998 346.3325L975.0349999999999 455.2175000000001L782.5949999999999 262.7775000000002z" : "M564.536 964.784C320.79 964.784 123.182 767.1759999999999 123.182 523.43V492.626H0V523.43C0 835.21 252.756 1087.966 564.536 1087.966S1129.072 835.2099999999999 1129.072 523.43V492.626H1005.8899999999998V523.43C1005.8899999999998 767.1759999999999 808.2819999999999 964.784 564.536 964.784zM626.11 210.222V605.54H502.9279999999999V210.222L348.976 364.174L261.868 277.0659999999999L520.88 18.0539999999999C544.986 -6.0520000000001 584.018 -6.0520000000001 608.124 18.0539999999999L867.136 277.0660000000001L780.0279999999999 364.1740000000001L626.0759999999999 210.2220000000001z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
DownloadOffline.displayName = `Blueprint5.Icon.DownloadOffline`;
export default DownloadOffline;
